import type { IImageConfig } from 'components/atoms/image/entities/types';

export const imageConfig: IImageConfig = {
    sources: [
        {
            media: '(min-width: 1024px)',
            sizes: {
                value: 600,
                unit: 'px',
            },
        },
    ],
};
